import { connectPagination } from "react-instantsearch-dom";

const Pagination = ({ currentRefinement, nbPages, refine, createURL }) => (
  <div className="paging form__paging paging--alt">
    <ul>
      {new Array(nbPages).fill(null).map((_, index) => {
        const page = index + 1;
        const style = {
          fontWeight: currentRefinement === page ? "600" : "",
          backgroundColor: currentRefinement === page ? "rgba(231, 185, 64, 0.3)" : "", 
        };

        return (
          <li key={index}>
            <a
              href={createURL(page)}
              style={style}
              data-page-number={index}
              onClick={(event) => {
                event.preventDefault();
                refine(page);
              }}
            >
              {page}
            </a>
          </li>
        );
      })}
    </ul>
  </div>
);
const DirectoryPagination = connectPagination(Pagination);
export default DirectoryPagination;
